import React, { useState } from 'react';
import * as Yup from 'yup';
import {
  GridView,
  CrudMasterDetailView,
  FormDatePicker,
  Widget,
  CompositeView,
  MasterDetailForm,
  FormInput,
  FormSelect,
  FormTextArea,
  FormSubmitButton,
  FormatText,
  CrudContext,
  ButtonDelete,
  useRouter,
} from '@digital/ui';
import { getAllDiretorias, createDiretoria, updateDiretoria, deleteDiretoria } from '@app/api/diretoria';
import { getAllUsuariosMRNAndTerceiroOptions, getAllDiretorOptions, getAllUsuariosPlanejamentoControleGASOptions } from '@app/api/usuario';
import { hasPermission } from '@app/helpers/permissions';

const Diretoria = () => {
  const [GetAllItems, setGetAllItems] = useState(() => {
    return getAllDiretorias;
  });

  const { history } = useRouter();

  const onCreateDiretoria = (values: any) => {
    return createDiretoria(values).then(resp => {
      if (resp.valid) {
        setGetAllItems(() => Promise.resolve(undefined));
        setGetAllItems(() => getAllDiretorias);
      }
      return resp;
    });
  };

  const onUpdateDiretoria = (values: any) => {
    return updateDiretoria(values).then(resp => {
      if (resp.valid) {
        setGetAllItems(() => Promise.resolve(undefined));
        setGetAllItems(() => getAllDiretorias);
      }
      return resp;
    });
  };

  return (
    <CrudMasterDetailView
      getAllItems={GetAllItems}
      createItem={hasPermission(['DIRETORIA_CADASTRAR']) ? onCreateDiretoria : undefined}
      updateItem={onUpdateDiretoria}
      icon="business-flow_chart"
      filterPredicate={(item, value) =>
        item.nome.toLowerCase().includes(value.toLowerCase()) ||
        (item.sigla ? item.sigla.toLowerCase().startsWith(value.toLowerCase()) : false)
      }
      disableNotification
      titleExtractor={d => d.nome}
      detailTitleExtractor={x => x.sigla + ' - ' + x.nome}
      descriptionExtractor={d => d.sigla || ''}>
      <CompositeView>
        <CrudContext.Consumer>
          {({ selectedItem }) => {
            return (
              <GridView noform>
                <MasterDetailForm
                  validationSchema={Yup.object().shape({
                    nome: Yup.string()
                      .required('Nome requerido')
                      .max(150, 'O nome deve ter no máximo 150 caracteres.'),
                    sigla: Yup.string()
                      .required('Sigla requerido')
                      .max(5, 'A sigla deve ter no máximo 5 caracteres.'),
                    descricao: Yup.string().max(2000, 'A descrição deve ter no máximo 2000 caracteres.'),
                  })}>
                  <Widget
                    title="Dados de Diretoria"
                    actions={[
                      selectedItem && hasPermission(['DIRETORIA_DELETAR']) && (
                        <ButtonDelete
                          icon={null}
                          type="danger"
                          confirm="Deseja realmente excluir este registro?"
                          okText="Confirmar"
                          onClick={() => {
                            deleteDiretoria(selectedItem.id).then((resp: any) => {
                              if (resp.valid) {
                                setGetAllItems(() => Promise.resolve(undefined));
                                setGetAllItems(() => getAllDiretorias);
                                history.push('/diretorias');
                              }
                            });
                          }}
                        />
                      ),
                      hasPermission(['DIRETORIA_CADASTRAR', 'DIRETORIA_EDITAR']) && (
                        <FormSubmitButton noIcon={true} type="primary">
                          <FormatText id="ui.commons.save" uppercase />
                        </FormSubmitButton>
                      ),
                    ]}>
                    <FormInput label="Nome" name="nome" span={4} />
                    <FormInput label="Sigla" name="sigla" span={2} />
                    <FormSelect
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input: any, item: any) => {
                        return item.props.children.props.id
                          .toString()
                          .toLowerCase()
                          .startsWith(input.toLowerCase());
                      }}
                      label="Responsável"
                      name="usuarioId"
                      getOptions={getAllUsuariosMRNAndTerceiroOptions}
                      span={6}
                    />
                    <FormSelect
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input: any, item: any) => {
                        return item.props.children.props.id
                          .toString()
                          .toLowerCase()
                          .startsWith(input.toLowerCase());
                      }}
                      label="Responsável Substituto"
                      name="usuarioSubstitutoId"
                      allowClear={true}
                      placeholder="Selecione uma opção"
                      getOptions={getAllDiretorOptions}
                      span={6}
                    />
                    <FormDatePicker format="DD/MM/YYYY" label="Data Inicial" name="dataInicial" span={3} />
                    <FormDatePicker format="DD/MM/YYYY" label="Data Final" name="dataFinal" span={3} />
                    <FormSelect
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input: any, item: any) => {
                        return item.props.children.props.id
                          .toString()
                          .toLowerCase()
                          .startsWith(input.toLowerCase());
                      }}
                      label="Planejamento e Controle GAS"
                      name="usuarioPlanejamentoControleGASId"
                      allowClear={true}
                      placeholder="Selecione uma opção"
                      getOptions={getAllUsuariosPlanejamentoControleGASOptions}
                      span={3}
                    />
                    <FormSelect
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input: any, item: any) => {
                        return item.props.children.props.id
                          .toString()
                          .toLowerCase()
                          .startsWith(input.toLowerCase());
                      }}
                      label="Planejamento e Controle GAS Alternativo"
                      name="usuarioPlanejamentoControleGASAlternativoId"
                      allowClear={true}
                      placeholder="Selecione uma opção"
                      getOptions={getAllUsuariosPlanejamentoControleGASOptions}
                      span={3}
                    />
                    <FormDatePicker format="DD/MM/YYYY" label="Data Inicial" name="dataInicialPlanejamentoControleGASAlternativo" span={3} />
                    <FormDatePicker format="DD/MM/YYYY" label="Data Final" name="dataFinalPlanejamentoControleGASAlternativo" span={3} />
                  </Widget>
                </MasterDetailForm>
              </GridView>
            );
          }}
        </CrudContext.Consumer>
      </CompositeView>
    </CrudMasterDetailView>
  );
};

export default Diretoria;
